import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import genericHelpers from '../_utils/generic-helpers';
import LocationFormatter from '../_cart/location-formatter';

const StoreInfo = ({
  store,
  isSelected,
  onSelect,
  serviceAvailable,
  openHours,
}) => {
  const {
    id,
    name,
    storeType,
    address: { street, city, state, zipcode },
    distance,
  } = new LocationFormatter(store);

  const address = [
    street ? street + ' ' : '',
    [city, [state, zipcode].filter(Boolean).join(' ')].join(', '),
  ].filter(Boolean);

  const closingTime = store?.operationalHours?.monToFriHrs?.endHr

  return (
    <div className="form-check mb-3 store-details">
      <input
        className="mr-2 form-check-input store-checkbox"
        type="radio"
        name="selectedStore"
        id={`store-${id}`}
        value={id}
        checked={isSelected}
        onChange={() => onSelect(id)}
        aria-checked={isSelected}
        aria-labelledby={`${name}-id`}
      />
      <label className="form-check-label" htmlFor={`store-${id}`}>
        <h5 className="mb-1">
          {name}, {genericHelpers.capitalizeWordsInString(storeType)}
        </h5>
        <p className="mb-0">{address}</p>
        {closingTime &&
        <p className="mb-0">
          {`Open until ${closingTime}`}
          {distance && typeof distance.miles === 'number'
            ? ` | ${distance.miles} miles`
            : ''}
        </p>
        }
        {serviceAvailable ? (
          <p className="text-success" aria-live="polite">
            {' '}
            Available at this store
          </p>
        ) : (
          <p className="text-danger" aria-live="polite">
            {' '}
            Not available at this store
          </p>
        )}
      </label>
    </div>
  );
};

StoreInfo.propTypes = {
  store: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    address: PropTypes.shape({
      rows: PropTypes.arrayOf(PropTypes.string),
      zipcode: PropTypes.string,
    }),
    distance: PropTypes.oneOfType([PropTypes.string, PropTypes.number, null]),
  }),
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  serviceAvailable: PropTypes.bool,
  openHours: PropTypes.string,
};

export default StoreInfo;
